import userManager from '../../auth/userManager';

const AuthorizeService = {
  getAccessToken: async (): Promise<string | undefined> => {
    const user = await userManager.getUser();
    return user?.access_token;
  }
};

export default AuthorizeService;
